import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARGiroActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Giro/GiroBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARGiro"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARGiro"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARGiroActivity)
